export const STANDARD_PACKAGE_NAME = 'Standard E-Invitation Package';
export const STANDARD_PACKAGE_PRICE = 800;
export const STANDARD_PACKAGE_TURNAROUND = '2-3 days';

export const standardPackageFeatures = [
  'Personalized Event E-Invitation Website',
  'Theme-Based Custom Design',
  'Animated Welcome Screen',
  'Interactive "Open Invitation" Button',
  'Personalized Cover Page',
  'Main or Cover Photo',
  'Event Title & Celebrant/Couple Name Display',
  'Event Date & Time Display',
  'Live Countdown Timer',
  'Background Music Integration',
  'Personalized Invitation Message',
  'Event Details Section',
  'Special Participants Section (Entourage, 18 Roses, 18 Candles, Godparents, etc.)',
  'Photo Gallery & Save the Date Video',
  'Dress Code Information',
  'Event Program Timeline',
  'Event Location Details',
  'Google Maps Integration',
  'Gift Guide & Registry',
  'Guest Reminders & FAQs',
  'Special Instructions Section',
  'RSVP Form with Guest Tracking',
  'Event Hashtags Display',
  'Personalized Shareable Link',
  'Mobile Responsive Design',
  'Accessible on Any Device',
  'Seat & Attendee Tracker',
  'Up to 10 High-Quality Photos',
  'Open Graph (OG) Preview',
  '2-3 Days Turnaround Time',
];

export const bookingAddOnOptions = [
  {
    id: 'unli-revisions',
    label: 'Unlimited Revisions',
    price: 500,
    description: 'Ensure every detail is perfect with unlimited revision rounds after the initial draft.',
  },
  {
    id: 'additional-pictures',
    label: 'Additional Pictures',
    price: 300,
    description: 'Showcase more memories by expanding your photo gallery up to 50 high-quality photos.',
  },
  {
    id: 'printable-version',
    label: 'Printable Version',
    price: 400,
    description: 'Receive a print-friendly layout optimized for high-quality physical or digital sharing.',
  },
  {
    id: 'individual-rsvp-website',
    label: 'Individual RSVP Website',
    price: 300,
    description: 'Create a separate RSVP site for a personalized guest flow and individual responses.',
  },
  {
    id: 'website-photo-album',
    label: 'Website Photo Album',
    price: 1000,
    description: 'Allow guests to upload and download photos directly. Files are retained for one week post-event.',
  },
  {
    id: 'rsvp-rush-order',
    label: 'RSVP Rush Order',
    price: 200,
    description: 'Get priority same-day turnaround for your RSVP setup.',
  },
  {
    id: 'einvitation-rush-order',
    label: 'E-Invitation Rush Order',
    price: 300,
    description: 'Receive your complete e-invitation website within the same day of submission.',
  },
];

export const bookingNotes = [
  '📌 Complete and Final Event Details Required –',
  'To ensure fast and accurate creation, please submit complete and finalized information. Changes after submission may be subject to additional charges.',
];

export const featureCategories = [
  {
    id: 'design',
    icon: '🎨',
    name: 'Design Features',
    count: 5,
    features: [
      'Personalized Event E-Invitation Website',
      'Theme-Based Custom Design',
      'Animated Welcome Screen',
      'Personalized Cover Page',
      'Interactive "Open Invitation" Button',
    ],
  },
  {
    id: 'content',
    icon: '📝',
    name: 'Content Features',
    count: 8,
    features: [
      'Event Title & Celebrant/Couple Name Display',
      'Event Date & Time Display',
      'Event Details Section',
      'Special Participants Section (Entourage, 18 Roses, 18 Candles, Godparents, etc.)',
      'Event Program Timeline',
      'Guest Reminders & FAQs',
      'Special Instructions Section',
      'Event Hashtags Display',
    ],
  },
  {
    id: 'media',
    icon: '📸',
    name: 'Media Features',
    count: 7,
    features: [
      'Main or Cover Photo',
      'Photo Gallery & Save the Date Video',
      'Background Music Integration',
      'Personalized Invitation Message',
      'Dress Code Information',
      'Gift Guide & Registry',
      'Up to 10 High-Quality Photos',
    ],
  },
  {
    id: 'integration',
    icon: '🔗',
    name: 'Integration Features',
    count: 5,
    features: [
      'Google Maps Integration',
      'Open Graph (OG) Preview',
      'Personalized Shareable Link',
      'Mobile Responsive Design',
      'Accessible on Any Device',
    ],
  },
  {
    id: 'tracking',
    icon: '📊',
    name: 'Tracking Features',
    count: 5,
    features: [
      'RSVP Form with Guest Tracking',
      'Seat & Attendee Tracker',
      'Live Countdown Timer',
      'Event Date & Time Display',
      '2-3 Days Turnaround Time',
    ],
  },
];

export const trustSignals = [
  { icon: '⚡', label: 'Fast Turnaround', description: '2-3 days standard' },
  { icon: '✓', label: 'Satisfaction Guarantee', description: 'Unlimited revisions available' },
  { icon: '🎯', label: 'Expert Support', description: 'Dedicated to your success' },
];

export const priceBreakdown = [
  { label: 'Design Work', amount: 300, percentage: 37.5 },
  { label: 'Development', amount: 350, percentage: 43.75 },
  { label: 'Support & Delivery', amount: 150, percentage: 18.75 },
];

export const processTimeline = [
  { step: 1, label: 'Book', description: 'Secure your spot today' },
  { step: 2, label: 'Submit Details', description: 'Share event information (24h)' },
  { step: 3, label: 'Review Draft', description: 'We craft your invitation (2-3 days)' },
  { step: 4, label: 'Go Live', description: 'Share with your guests!' },
];

export function formatPeso(value) {
  return `\u20b1${Number(value || 0).toLocaleString('en-PH')}`;
}
